<header>
  <div class="container">
    <div class="d-flex flex-row justify-content-between">
      <a class="navbar-brand" routerLink="/home">
        <img [src]="logoSrc$ | async" [attr.alt]="'menu.header.image.logo' | translate"/>
      </a>

      <nav role="navigation" [attr.aria-label]="'nav.user.description' | translate" class="navbar navbar-light navbar-expand-md flex-shrink-0 px-0">
        <!-- BfS: Suchleiste im Header, auf der Startseite ausgeblendet -->
        <ds-search-navbar *ngIf="(isHomePage$ | async) === false"></ds-search-navbar>
        <ds-lang-switch class="nav-lang-item"></ds-lang-switch>
        <ds-context-help-toggle></ds-context-help-toggle>
        <ds-auth-nav-menu></ds-auth-nav-menu>
        <ds-impersonate-navbar></ds-impersonate-navbar>
        <div *ngIf="isMobile$ | async" class="pl-2">
          <button class="navbar-toggler px-0" type="button" (click)="toggleNavbar()"
                  aria-controls="collapsingNav"
                  aria-expanded="false" [attr.aria-label]="'nav.toggle' | translate">
            <span class="fas fa-bars fa-fw toggler-icon" aria-hidden="true"></span>
          </button>
        </div>
      </nav>
    </div>
  </div>
</header>
